import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IconSettings } from '@salesforce/design-system-react';
import { Textarea } from '@salesforce/design-system-react';

export const LongText = ({ enabled, required, label, fieldName, length, handleChange, error, defaultValue }) => {
  const [longText, setLongText] = useState('');

  useEffect(() => {
    setLongText(defaultValue);
  }, [defaultValue]);

  return (
    <div className='longtext-field'>
      <IconSettings iconPath="/assets">
        <Textarea
          className={'time-largetext-textarea'}
          label={label}
          value={longText}
          disabled={!enabled}
          required={required}
          name={fieldName}
          errorText={error}
          maxLength={length}
          onChange={(event) => {
            setLongText(event.target.value);
            handleChange(event, { fieldName, value: event.target.value });
          }}
        />
      </IconSettings>
    </div>
  );
};

LongText.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  length: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.string,
  defaultValue: PropTypes.string,
};
